export default [
    {
        path: '/dashboard/analytics',
        name: 'dashboard-analytics',
        component: () => import('@/views/dashboard/analytics/Analytics.vue'),
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/views/dashboard/ecommerce/Dashboard.vue'),
    },
]
